import { UserPaymentDetailsTypeId } from '@starsoft/common/enums';
import { UserPaymentDetails } from '@starsoft/common/models';

export function getUserPaymentDetailsFieldByTypeId(
  userPaymentDetail?: UserPaymentDetails,
) {
  switch (userPaymentDetail?.type?.id?.toString()) {
    case UserPaymentDetailsTypeId.Pix?.toString():
      return userPaymentDetail?.pix?.maskedKey;
    case UserPaymentDetailsTypeId.Imps?.toString():
      return userPaymentDetail?.imps?.accountNumber;
    case UserPaymentDetailsTypeId.ArgentineBankAccount?.toString():
    case UserPaymentDetailsTypeId.MexicanBankAccount?.toString():
    case UserPaymentDetailsTypeId.SingaporeBankAccount?.toString():
    case UserPaymentDetailsTypeId.NigerianBankAccount?.toString():
    case UserPaymentDetailsTypeId.SouthAfricaBankAccount?.toString():
      return userPaymentDetail?.bankAccount?.account;
  }
}
